import { render, staticRenderFns } from "./GeneralLayout.vue?vue&type=template&id=9ff201e6&scoped=true"
import script from "./GeneralLayout.vue?vue&type=script&lang=js"
export * from "./GeneralLayout.vue?vue&type=script&lang=js"
import style0 from "./GeneralLayout.vue?vue&type=style&index=0&id=9ff201e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff201e6",
  null
  
)

export default component.exports